import Fulllayout from '../layouts/fulllayout.js';

var indexRoutes = [
    { path: '/', name: 'Flights', component: Fulllayout }
    // { path: '/', name: 'Dashboard', component: Fulllayout }

];

export default indexRoutes;
